import cn from 'classnames'
import { FC } from 'react'
import { FieldError } from 'react-hook-form'
import tw from 'tailwind-styled-components'

export type FormElementProps = {
    error?: FieldError
    name: string
    label?: string
}

export const FormLabel = tw.label`
gray-800
text-xs
font-bold
uppercase
`

const Content = tw.div`mt-1 relative rounded-md shadow-sm`

export const inputClass = cn(
    'bg-transparent focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300',
    'border border-primaryt rounded-md',
)

export const withInputClass = (className?: string) =>
    [inputClass, className ?? ''].join(' ')

export const FormElement: FC<FormElementProps> = ({
    name,
    error,
    children,
    label,
}) => (
    <div>
        <FormLabel htmlFor={name}>{label ?? ''}</FormLabel>
        <Content>
            {children}
            {error && <div>{error.message}</div>}
        </Content>
    </div>
)

export default FormElement
